import { render, staticRenderFns } from "./BankBalance.vue?vue&type=template&id=5403f879&scoped=true"
import script from "./BankBalance.vue?vue&type=script&lang=js"
export * from "./BankBalance.vue?vue&type=script&lang=js"
import style0 from "./BankBalance.vue?vue&type=style&index=0&id=5403f879&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5403f879",
  null
  
)

export default component.exports